/**
 * SIC 2007: the 2-digit division sets the section (A–U), following the ONS ranges.
 * Companies House also uses 99999 "Dormant company", and a company may have no SIC code at all.
 * Both go to the pseudo-section "X" so they don't appear as section U (extraterritorial orgs) on the map.
 */
const RANGES: ReadonlyArray<readonly [number, number, string]> = [
  [1, 3, "A"], [5, 9, "B"], [10, 33, "C"], [35, 35, "D"], [36, 39, "E"],
  [41, 43, "F"], [45, 47, "G"], [49, 53, "H"], [55, 56, "I"], [58, 63, "J"],
  [64, 66, "K"], [68, 68, "L"], [69, 75, "M"], [77, 82, "N"], [84, 84, "O"],
  [85, 85, "P"], [86, 88, "Q"], [90, 93, "R"], [94, 96, "S"], [97, 98, "T"], [99, 99, "U"],
];

export const SECTION_LABELS: Record<string, string> = {
  A: "Agriculture, forestry & fishing", B: "Mining & quarrying", C: "Manufacturing",
  D: "Energy supply", E: "Water & waste", F: "Construction", G: "Wholesale & retail",
  H: "Transport & storage", I: "Hospitality", J: "Information & communication",
  K: "Finance & insurance", L: "Real estate", M: "Professional & scientific",
  N: "Admin & support services", O: "Public administration", P: "Education",
  Q: "Health & social work", R: "Arts & recreation", S: "Other services",
  T: "Households as employers", U: "Extraterritorial organisations", X: "Not stated",
};

/** Normalise a SIC value ("62020", "1110", "62020 - Business and …") to a 5-digit TEXT code. */
export function normaliseSic(raw: string | null | undefined): string | null {
  const m = raw?.trim().match(/^(\d{4,5})\b/);
  return m?.[1] ? m[1].padStart(5, "0") : null;
}

export function sicSection(code: string | null | undefined): string {
  const c = normaliseSic(code);
  if (!c || c === "99999") return "X";
  const div = Number(c.slice(0, 2));
  for (const [lo, hi, s] of RANGES) if (div >= lo && div <= hi) return s;
  return "X";
}
